import StreamComponent from './StreamComponent';
import '@aws-amplify/ui-react/styles.css';
import { Amplify } from 'aws-amplify';
import { Authenticator } from '@aws-amplify/ui-react';

Amplify.configure({
    Auth: {
        Cognito: {
            // example: 'us-west-2_CmhpQV4GR'
            userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID ?? '<CHANGE-ME>',
            // example: '5b9h9bmmmva3ig1trmq5n90orm'
            userPoolClientId: process.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID ?? '<CHANGE-ME>'
        }
    },
    API: {
        REST: {
            'demo-api': {
                // example: 'https://2ki03xizx7.execute-api.us-west-2.amazonaws.com/prod'
                // ensure the endpoint has no trailing slash '/' at the end
                endpoint: process.env.REACT_APP_API_ENDPOINT ?? '<CHANGE-ME>'
            }
        }
    }
});


function App() {
    return (
        <Authenticator hideSignUp={true} loginMechanisms={['email']}>
            {() => (
                <StreamComponent />
            )}
        </Authenticator>
    );
}

export default App;

